export default "__VITE_ASSET__a75faebb__"